import { regStepIds } from '../../../../../utils/eventConstants';
import { getStepAfterDivisionSelection } from '../../../../../utils/registrationSteps';

// The password is collected before the gate, so an upgrade never needs to route back to it.
export function getStepAfterUpgrade({ sidebarFlow, event, isCampEvent, isMultiRegistrationAllowed, isHybridGate, unRegisteredPlayers }) {
    if (sidebarFlow === regStepIds.DIVISIONS_ADD) {
        return regStepIds.DIVISIONS_ADD;
    }
    if (sidebarFlow === regStepIds.DIVISIONS_SWITCH) {
        return regStepIds.DIVISIONS_ADD;
    }
    // On a hybrid event the gate fires after the player has already chosen divisions, so
    // send them on to where Continue would have gone rather than back to the list. An
    // all-Power event gates before any selection exists, so it still starts at DIVISIONS.
    if (isHybridGate) {
        return getStepAfterDivisionSelection({ event, unRegisteredPlayers });
    }
    if (isCampEvent && isMultiRegistrationAllowed) {
        return regStepIds.CAMP_USER_SELECTION;
    }
    return regStepIds.DIVISIONS;
}
